interface FilterGroupProps {
  label: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
}

export default function FilterGroup({ label, options, selected, onToggle, onClear }: FilterGroupProps) {
  return (
    <div className="py-4 border-b border-background-200 last:border-b-0">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-foreground-900">{label}</span>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs text-primary-600 hover:text-accent-600 transition-colors cursor-pointer"
          >
            清除
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              className={`px-3 h-8 rounded-md text-xs border transition-colors whitespace-nowrap cursor-pointer ${
                active
                  ? "border-primary-600 bg-primary-600 text-background-50"
                  : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}